import { useIntegratedForm } from '../../../forms/use-integrated-form';
import { BoloPanelFormType } from '@mark43/cad-api';
import { useFormState } from 'react-hook-form';
import { Divider, VStack, Box, InlineBanner } from '@cad-arc';
import React from 'react';
import { BoloPanelFormBody } from '../form/bolo-form-body';
import { useBoloPanelMetadata } from '../state/bolo-panel-metadata-context';
import { useExpandablePanelSize } from '../../../panels/expandable-panel-size';
import { BoloPanelTabs } from './tabs/bolo-panel-tabs';
import { BoloAdditionalInfos } from '../additional-infos/bolo-additional-infos';
import {
    EntityPanelGroupHeader,
    NARRATIVE_PANEL_WITH_TWO_INFOS_HEIGHT,
} from '../../../panels/entity-panels/entity-panel-components';

export const BoloPanelLeftPane = () => {
    const boloForm = useIntegratedForm<BoloPanelFormType>().form;
    const boloPanelSize = useExpandablePanelSize();

    const { isValid, isSubmitted } = useFormState({
        control: boloForm.control,
    });
    const isSavedBolo = !!useBoloPanelMetadata()?.boloId;

    return (
        <VStack spacing={0} height="100%" w="500px" overflowX="hidden">
            <VStack w="100%" h="100%" overflowY="auto" flexGrow={1} position="relative" spacing={0}>
                <VStack w="100%" p={4} flex="1" alignItems="flex-start">
                    {!isValid && isSubmitted ? (
                        <InlineBanner
                            style={{ width: '100%' }}
                            status="error"
                            description="One or more issues need to be fixed"
                        />
                    ) : undefined}
                    <BoloPanelFormBody />
                </VStack>
                {isSavedBolo && boloPanelSize === 'NORMAL' && (
                    <VStack w="100%">
                        <VStack px={4} w="100%" gap={2} alignItems="flex-start">
                            <Divider />
                            <EntityPanelGroupHeader title="Updates" />
                        </VStack>
                        <Box
                            w="100%"
                            flexGrow={1}
                            h="100%"
                            overflowY="auto"
                            minH={NARRATIVE_PANEL_WITH_TWO_INFOS_HEIGHT}
                        >
                            <BoloAdditionalInfos />
                        </Box>
                    </VStack>
                )}
            </VStack>
            {(isSavedBolo && boloPanelSize !== 'XXL') || boloPanelSize === 'NORMAL' ? (
                <BoloPanelTabs mode="INLINE" />
            ) : undefined}
        </VStack>
    );
};
